angular.module('Mineler').run(['$templateCache', function($templateCache) {
  $templateCache.put('map/toolbars/toolbars.tpl.html',
    '<div id="map-toolbars-container" class="row">\n' +
    '  <div class="small-15 medium-6 medium-push-5 large-7 large-push-5 columns map-toolbar-container" ng-include="\'map/toolbars/favourite-users/favourite-users.tpl.html\'"></div>\n' +
    '  <div id="map-menu-container" class="small-15 medium-4 medium-push-5 large-3 large-push-5 columns map-toolbar-container" ng-include="\'map/toolbars/menu.tpl.html\'"></div>\n' +
    '  <div class="small-15 medium-5 medium-pull-10 large-5 large-pull-10 columns map-toolbar-container" ng-include="\'map/toolbars/search/search.tpl.html\'"></div>\n' +
    '</div>\n' +
    '');
}]);
